import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { schoolLicenseUpdatesQueryOptions } from "../../../api/useSchoolLicenseUpdates";
import LicenseUpdatesPage from "../../../pages/Admin/LicenseUpdatesPage/LicenseUpdatesPage";
import { convertDateToYYYYMMDD } from "../../../helpers/time.helpers";

export const Route = createFileRoute("/(app)/admin/license-updates")({
  component: RouteComponent,
  loaderDeps: ({ search }) => ({
    from: search.from,
    to: search.to,
  }),
  loader: ({ context, deps }) => {
    const { from, to } = deps;
    return context.queryClient.ensureQueryData(
      schoolLicenseUpdatesQueryOptions({ from, to })
    );
  },
  validateSearch: (search: Record<string, unknown>) => {
    return {
      locations: (search.locations as string[]) || [
        "se",
        "no",
        "fi",
        "fr",
        "ee",
      ],
      stack: (search.stack as boolean) || false,
      dots: (search.dots as boolean) || false,
      filter: (search.filter as string) || "",
      from: (search.from as string) || "2023-01-01",
      to: (search.to as string) || convertDateToYYYYMMDD(new Date()),
    };
  },
});

function RouteComponent() {
  const { from, to } = Route.useSearch();
  const { data } = useSuspenseQuery(
    schoolLicenseUpdatesQueryOptions({ from, to })
  );
  return <LicenseUpdatesPage data={data} />;
}
